<template>
  <div class="standart-page">
    <div class="row mb-3">
      <div class="col d-flex align-items-center justify-content-center">
        <h3 class="title mb-0">Ayarlar</h3>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-5 d-flex justify-content-center">
        <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 0 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(0, 'Authorizations')">
            Yetkiler
        </button>
        <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 1 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(1, 'SystemLog')">
            Sistem Logları
        </button>
        <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 2 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(2, 'SessionInfos')">
            Açık Oturumlar
        </button>
        <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 3 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(3, 'JobInfos')">
            İş Akışları
        </button>
        <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 4 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(4, 'SystemFile')">
            Sistem Dosyaları
        </button>
      </div>
    </div>
    <component :is="$store.state.settings.currentTab" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    ...mapActions("settings", ["changeDetailTab"]),
    changeComponent(id, cmp) {
      this.activeTab = id;
      this.changeDetailTab(cmp);
    }
  },
  created() {
    this.changeComponent(0, "Authorizations");
  },
  computed: {
    ...mapGetters("general", ["getMessage"]),
  },
  watch: {},
};
</script>